export namespace HybridEn {
    export function factory() {
        return {
            header: {
                home: 'Home',
                property: 'Properties',
                blog: 'Blogs',
            },
            footer: {
                admin: ' Admin ',
                copyright: 'Copyright © 2019 Powered by RIFO',
            },
            '1': 'We will inform you the detailed information of the service provider, meanwhile service provider will received your information from us.', // appointment body-info
            '2': 'Client', // appointment client name
            '3': 'Schedule Appointment', // submit button
            '4': 'Expiry Date', // expiry Date
            '5': 'Customer Services', // customer Services
            '6': 'Appointment Confirmed', // appointment success body title
            '7': 'Thank you for choosing RIFO, to check your order status please click "MY ORDER"', // hybrid-services-appointment-body-info
            '8': 'Home Page', // go home
            '9': 'My Order', // go my order
            '10': 'Purchase Succeed', // purchase succeed
            '11': 'Thank you for choosing RIFO, to check your purchased coupons, please click "MY COUPON"', // purchase succeed thx
            '12': 'Transaction Cancelled', // purchase cancelled
            '13': 'Transaction Cancelled, Please contact customer service if you have any questions', // after purchase cancelled
            '14': 'Transaction Failed', // purchase failed
            '15': 'Transaction Cancelled, Please try again later. if you are having trouble placing order, please contact customer service.', // after purchase failed please
            '16': 'Go back', // go back
            '17': 'User info error, please contact customer service ASAP', // user info error
            '18': 'RIFO Coupon', // default coupon title
            '19': 'save money/ save time/ worry less', // default coupon subtitle
            '20': 'Login/Register', // login button
            '21': 'My Account', // go my account
            '22': 'Purchase', // go paypage
            '23': 'Schedule Appointment', // appointment
            '24': 'My Order', // go my order
            '25': 'Inactive', // inactive
            '26': 'Refunded', // REFUNDED
            '27': 'Deleted', // DISCARDED
            '28': 'House Purchasing with Rewards', // default slogan
            '29': 'Find out more details in App', // find detials
            '30': 'Resend', // resend
            '31': 'Send Verify Code \r\nEdit Phone Numbe, \r\n *notice: this action will motify the phone number in user account', //
            '32': 'Verify Code Error',
            '33': 'Appointment Succeed',
            '34': 'Thank you for choosing RIFO, we are asigning service, please check later.',
            '35': 'Phone Number (10 digits)', // phoneInput placeholder
            '36': 'Verifiy Code', // codeVarify placeholder
            '37': 'Phone number has been resgistered, please double check with Customer Service: (416) 883-9666',
            '38': 'Time Out',
            '39': 'Resend',
            '40': 'Detail',
            '41': 'Expired',
            '42': 'Expiry Date',
            '43': 'My Coupons',
            '44': 'Redeem', // appointment
            '45': 'Not Issued', // appointment
            '46': 'RIFO HOME VALUATION',
            '47': 'How much is my home worth?',
            '48': 'Get a free home value estimate from a agent',
            '49': 'Get My Instant Estimate',
            marketingTrend: {
                '1': 'Last 1 Month',
                '2': 'Median Price',
                '3': 'New Listing',
                '4': 'Median Price Change Yearly',
                '5': 'Median Price Change Monthly',
                '6': 'Sales',
                '7': 'Average Days On Market',
                '8': 'Avg Sold Price',
                '9': 'Sale-to-List Ratios',
                'graph1': {
                    'title': 'Sold Price & Average Days On Market',
                    'label1': 'Days On Market',
                    'label2': 'Median Price',
                    'label3': 'Price / K',
                    'label4': 'DOM / day',
                },
                'graph2': {
                    'title': 'Avg Sold Price / K',
                },
                'graph3': {
                    'title': 'Median Price / K',
                },
                'graph4': {
                    'title': 'Average Days On Market / day',
                },
                'graph5': {
                    'title': 'Sale-to-List Ratios %',
                },
                'graph6': {
                    'title': 'Sales',
                },
                'graph7': {
                    'title': 'Property Type Distribution (180 days)',
                },
                'graph8': {
                    'title': 'Sold Price Distribution (180 days)',
                    'label1': 'Count (K）'
                },
                'graph9': {
                    'title': 'Sold / New / Active Listings',
                    'label1': 'Sold',
                    'label2': 'New',
                    'label3': 'Active'
                },
                'graph10': {
                    'title': 'Market Temperature',
                    'label1': 'absorption rate',
                    'label2': 'absorption month',
                    'formatter': '{b1}<br/>rate: {c0}<br/>month: {c1}',
                    'p1': `Absorption Month: As a general rule, 5 to 6 is considered to be normal or balanced. More than 6 indicates buyer's market.
                     Less than 5 months indicates seller's market.`,
                    'p2': `Absorption Rate: Normally, more than 20% indicates seller's market in which properties will be sold fast.
                     Less than 15% is an indicator of buyer's market, in which sales are relatively slow.
                    `
                }
            },
            communityTrend: {
                '1': 'Explore Neighbourhood',
                '2': 'Economic Region:',
                '3': 'Province:',
                '4': 'Census Division:',
                '5': 'Citizen',
                '6': 'Not Citizen',
                '7': 'Owner',
                '8': 'Renter',
                '9': 'Work In Usual Places',
                '10': 'Not Fixed',
            }
        };
    }
}
